import { useMemo } from 'react';

import './previewField.scss';
import TextField from './TextField';
import PhoneNumber from './Phone';
import TextArea from './TextArea';
import TextEditorArea from './TextEditor';
import Address from './Address';
import AddLabel from './AddLabel';
import DateTimeSelection from './DateTimeSelection';
import UploadField from './UploadField';
import OptionsField from './OptionsField';
import TableFields from './TableFields';
import { TPreviewFieldProps } from './previewField.types';

const PreviewField = ({
  id,
  label,
  placeholder,
  type,
  sectionId,
  required,
  options,
  validations,
  response,
  files,
  hasCharacterLimit,
  createProgramStep
}: TPreviewFieldProps) => {
  const fieldComponent = useMemo(() => {
    const fieldProps = {
      id,
      sectionId,
      label,
      placeholder,
      type,
      required,
      options,
      validations,
      response,
      files,
      hasCharacterLimit,
      createProgramStep
    };
    console.log(type, 'typetype')
    if (type === 'textInput') {
      return <TextField {...fieldProps} />;
    }
    if (type === 'textArea') {
      return <TextArea {...fieldProps} />;
    }
    if (type === 'textEditor') {
      return <TextEditorArea {...fieldProps} />;
    }
    if (type === 'address') {
      return <Address {...fieldProps} />;
    }
    if (type === 'phoneNumber') {
      return <PhoneNumber {...fieldProps} />;
    }
    if (type === 'dropdown') {
      return (
        <OptionsField
          fieldTitle="Dropdown field"
          fieldPlaceholder="Multiple choice field title"
          {...fieldProps}
        />
      );
    }
    if (type === 'singleChoice') {
      return (
        <OptionsField
          fieldTitle="Single choice field"
          fieldPlaceholder="Single choice field title"
          {...fieldProps}
        />
      );
    }
    if (type === 'multipleChoice') {
      return (
        <OptionsField
          fieldTitle="Multiple choice field"
          fieldPlaceholder="Multiple choice field title"
          {...fieldProps}
        />
      );
    }
    if (type === 'tableColumns') {
      return (
        <TableFields
          fieldTitle="Table"
          fieldPlaceholder="Table title"
          {...fieldProps}
        />
      );
    }
    if (type === 'label') {
      return <AddLabel {...fieldProps} />;
    }
    if (type === 'dateSelection') {
      return <DateTimeSelection {...fieldProps} placeholder="Select date" inputType="date" />;
    }
    if (type === 'timeSelection') {
      return <DateTimeSelection {...fieldProps} placeholder="Select time" inputType="time" />;
    }
    if (type === 'fileUpload') {
      return <UploadField {...fieldProps} />;
    }
  }, [
    id,
    label,
    placeholder,
    type,
    sectionId,
    required,
    options,
    hasCharacterLimit,
    validations,
    response,
    files
  ]);

  return fieldComponent;
};

export default PreviewField;
